import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import server from "src/api/server";

import Seo from "src/components/shared/Seo";
const AboutPage = dynamic(() => import("src/modules/AboutPage/AboutPage"));

export default function About({
  data,

  appSetting = {},
  metaData = [],
  footerSettings,
}) {
  const router = useRouter();
  const { locale } = router;

  const customMeta = [
    { name: "title", content: metaData?.[0]?.name?.[locale] },
    {
      name: "description",
      content: metaData?.[0]?.content?.[locale],
    },
  ];

  return (
    <div>
      <Seo
        metaData={customMeta}
        appSetting={{
          ...appSetting,
          ...footerSettings,
        }}
        pageUrl={
          typeof window !== "undefined"
            ? window.location.href
            : `${process.env.NEXT_PUBLIC_SITE_URL}/${router.asPath}`
        }
      />

      <AboutPage data={data} />
    </div>
  );
}

export async function getStaticProps() {
  try {
    const [
      aboutUsRes,
      informationRes,
      statisticsRes,
      questionsRes,
      advantagesRes,
      teamMembersRes,
      metaRes,
      indexRes,
      footerRes,
    ] = await Promise.all([
      server.get("/api/posts/about_us/all"),
      server.get("/api/posts/about_us_info/all"),
      server.get("/api/posts/statistics/all"),
      server.get("/api/posts/questions/all"),
      server.get("/api/posts/advantages/all"),
      server.get("/api/posts/team_members/all"),
      server.get("/api/metadataTags?type=about"),
      server.get("/api/index"),
      server.get("/api/footer"),
    ]);

    const indexData = indexRes?.data?.data;
    const appSetting = indexData?.AppSetting;

    return {
      props: {
        data: {
          statistics: statisticsRes?.data?.data || null,
          questions: questionsRes?.data?.data || null,
          advantages: advantagesRes?.data?.data || null,
          about_us: aboutUsRes?.data?.data || null,
          information: informationRes?.data?.data || null,
          teamMembers: teamMembersRes?.data?.data || null,
        },
        metaData: metaRes?.data?.data?.metadata_tags || null,
        appSetting: appSetting || null,
        footerSettings: footerRes?.data?.data || null,
      },
      revalidate: 60,
    };
  } catch (error) {
    return {
      props: {
        data: {
          statistics: null,
          questions: null,
          advantages: null,
          about_us: null,
          information: null,
          teamMembers: null,
        },
        metaData: null,
        appSetting: null,
        footerSettings: null,
      },
      revalidate: 60,
    };
  }
}
